"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fileHelpers_1 = require("./fileHelpers");
var processingUtils_1 = require("../util/processingUtils");
var uploadStateEnum_1 = require("./uploadStateEnum");
var AzureTools = /** @class */ (function () {
    function AzureTools(axios) {
        this.axios = axios;
        this.blockIdPrefix = "block-";
    }
    AzureTools.prototype.uploadToAzureInBlocks = function (fileModel, uploadUrl, fnUpdateModel, maxBlockSize, concurrentRequests) {
        return __awaiter(this, void 0, void 0, function () {
            var file, size, type, blockDescs, blocks, i, c, _a, start, end, blockId, arrayBuffer, uint8Array, fnUpload, batches, blockPos, i, batch, _loop_1, j, _i, batches_1, batch;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        file = fileModel.file;
                        size = file.size, type = file.type;
                        blockDescs = this._generateBlockDescriptors(size, maxBlockSize);
                        blocks = [];
                        i = 0, c = blockDescs.length;
                        _b.label = 1;
                    case 1:
                        if (!(i < c)) return [3 /*break*/, 4];
                        if (fileModel.state === uploadStateEnum_1.FILE_STATUS.CANCELLED) {
                            return [2 /*return*/];
                        }
                        _a = blockDescs[i], start = _a.start, end = _a.end, blockId = _a.blockId;
                        return [4 /*yield*/, (0, fileHelpers_1.readFileSegmentAsArrayBufferAsync)(file, start, end)];
                    case 2:
                        arrayBuffer = _b.sent();
                        uint8Array = new Uint8Array(arrayBuffer);
                        fnUpload = function (uploadEvent, blockPos) {
                            blocks[blockPos].bytesUploaded = uploadEvent.loaded;
                            var bytesUploaded = blocks.reduce(function (a, o) { return a + o.bytesUploaded; }, 0);
                            fileModel.uploadProgress = Math.floor((bytesUploaded / size) * 100);
                            fnUpdateModel(fileModel);
                        };
                        blocks.push({
                            uint8Array: uint8Array,
                            blockId: blockId,
                            fnUpload: fnUpload,
                            bytesUploaded: 0,
                        });
                        _b.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        batches = [];
                        blockPos = 0;
                        for (i = 0; i < Math.ceil(blocks.length / concurrentRequests); i++) {
                            batch = [];
                            _loop_1 = function (j) {
                                var block = blocks[blockPos];
                                var request = (0, processingUtils_1.retry)(5000, 5, function () { return __awaiter(_this, void 0, void 0, function () {
                                    var err_1;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                _a.trys.push([0, 2, , 3]);
                                                return [4 /*yield*/, this._uploadBlob(fileModel, uploadUrl, type, block.uint8Array, block.blockId, block.uploadFunction, blockPos)];
                                            case 1:
                                                _a.sent();
                                                return [3 /*break*/, 3];
                                            case 2:
                                                err_1 = _a.sent();
                                                if (fileModel.state !== uploadStateEnum_1.FILE_STATUS.CANCELLED) {
                                                    throw err_1;
                                                }
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); });
                                batch.push(request);
                                blockPos++;
                            };
                            for (j = 0; j < concurrentRequests && blockPos < blocks.length; j++) {
                                _loop_1(j);
                            }
                            batches.push(batch);
                        }
                        _i = 0, batches_1 = batches;
                        _b.label = 5;
                    case 5:
                        if (!(_i < batches_1.length)) return [3 /*break*/, 8];
                        batch = batches_1[_i];
                        return [4 /*yield*/, Promise.all(batch)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        _i++;
                        return [3 /*break*/, 5];
                    case 8: return [4 /*yield*/, this._commitBlockList(fileModel, uploadUrl, type, blockDescs)];
                    case 9:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AzureTools.prototype._generateBlockDescriptors = function (fileSize, maxBlockSize) {
        var numberOfBlocks = Math.ceil(fileSize / maxBlockSize);
        var blockDescs = [];
        for (var i = 0; i < numberOfBlocks; ++i) {
            var start = i * maxBlockSize;
            var end = Math.min(start + maxBlockSize, fileSize);
            var blockId = btoa(this.blockIdPrefix + i.toString().padStart(6, "0"));
            blockDescs.push({
                start: start,
                end: end,
                blockId: blockId,
            });
        }
        return blockDescs;
    };
    AzureTools.prototype._uploadBlob = function (model, uploadUrl, contentType, requestData, blockId, uploadProgress, blockPos) {
        var uri = uploadUrl + "&comp=block&blockid=" + blockId;
        var config = {
            headers: {
                "x-ms-s-type": "BlockBlob",
                "content-type": contentType,
            },
            progress: false,
        };
        if (uploadProgress) {
            config.onUploadProgress = function (progressEvent) {
                uploadProgress(progressEvent, blockPos);
            };
        }
        return this._uploadData(model, uri, requestData, config);
    };
    AzureTools.prototype._createBlockListXml = function (blockDescriptions) {
        var parts = [];
        parts.push('<?xml version="1.0" encoding="utf-8"?><BlockList>');
        blockDescriptions.forEach(function (bd) {
            parts.push("<Latest>" + bd.blockId + "</Latest>");
        });
        parts.push("</BlockList>");
        return parts.join("");
    };
    AzureTools.prototype._commitBlockList = function (model, uploadUrl, contentType, blockDescriptions) {
        var uri = uploadUrl + "&comp=blocklist";
        var requestBody = this._createBlockListXml(blockDescriptions);
        var config = {
            headers: {
                "x-ms-blob-content-type": contentType,
                "content-type": "text/plain",
            },
            cancelToken: model.cancelToken.token,
        };
        return this._uploadData(model, uri, requestBody, config);
    };
    AzureTools.prototype._uploadData = function (model, url, data, config) {
        return this.axios.put(url, data, config);
    };
    return AzureTools;
}());
exports.default = AzureTools;
//# sourceMappingURL=azureTools.js.map